import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/luck-gift-world-cup',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-luck-gift-world-cup" */ '~/pages/LuckGiftWordCup/pages/world-cup-turntable-activity/Container'
        )
    ),
  },
  {
    path: '/luck-gift-world-cup/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-luck-gift-world-cup-rule" */ '~/pages/LuckGiftWordCup/pages/world-cup-rule-activity/Container'
        )
    ),
  },
  {
    path: '/luck-gift-world-cup/global-popup',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-luck-gift-world-cup-global-popup" */ '~/pages/LuckGiftWordCup/pages/world-cup-global-popup-activity'
        )
    ),
  },
] as RouteConfig[]
